import { Box, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { Project } from 'src/resources/api/project/types.api';
import { AppGridContainer, AppGridContent, AppSection } from 'src/components';

import Image from 'src/components/Image';
import { getListOfUniqSDGs } from 'src/utils/sustainableDevelopmentGoals';

//
//

type SDGCardProps = {
  projects: Project[];
  isRanged?: boolean;
};

export const ReportSDGCard: React.FC<SDGCardProps> = ({ projects, isRanged }) => {
  const listOfSDGs = useMemo(() => getListOfUniqSDGs(projects), [projects]);

  //

  return (
    <AppSection title="Sustainable development goals" sx={{ p: 0 }}>
      <Typography variant="body2">
        The United Nations Sustainable Development Goals (SDGs) are a set of 17 global objectives
        aimed at addressing pressing challenges such as poverty, inequality, climate change, and
        more. They provide a universal roadmap for a sustainable, equitable, and prosperous future.
      </Typography>

      <Typography variant="body2">
        {isRanged ? (
          <>
            The projects that the programme has supported in the report date range, including those
            that are no longer part of your current project portfolio, have contributed to{' '}
            <b>{listOfSDGs?.length || 0} Sustainable Development Goals</b>, making a positive impact
            on the planet and local communities.
          </>
        ) : (
          <>
            Since the start of the programme, the projects you’ve supported have contributed to{' '}
            <b>{listOfSDGs?.length || 0} Sustainable Development Goals</b>, making a positive
            impact on the planet and local communities.
          </>
        )}
      </Typography>

      <AppGridContainer spacing={1} columns={{ xs: 1, sm: 2 }}>
        {listOfSDGs?.map(
          (sdg, id) =>
            sdg && (
              <AppGridContent key={id} size={1}>
              <Stack
                spacing={2}
                direction="row"
                alignItems="center"
              >
                <Box>
                  <Image
                    sx={{ width: 60 }}
                    src={sdg?.imageUrl}
                    visibleByDefault
                    alt="project goal"
                  />
                </Box>
                <Stack>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    {sdg?.title}
                  </Typography>
                  <Typography sx={{ lineHeight: 1.3, fontSize: { xs: 12, md: 14 } }}>
                    {sdg?.description}
                  </Typography>
                </Stack>
              </Stack>
              </AppGridContent>
            )
        )}
      </AppGridContainer>
    </AppSection>
  );
};
